import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./businessAssurance.scss";

const VideoComponent = ({ currentLanguage }) => {

  if (currentLanguage === "en-US") {
    return (
      <>
        <iframe src="https://www.youtube.com/embed/EU4gRKo0Cls" title="YouTube video player"></iframe>
      </>
    )
  } else if (currentLanguage === "es") {
    return (
      <>
        <iframe src="https://www.youtube.com/embed/PsbJE2EBeqg" title="YouTube video player"></iframe>
      </>
    )
  }


  return (
    <>
      <iframe src="https://www.youtube.com/embed/Hg1yvVcQQu0" title="YouTube video player"></iframe>
    </>
  )
}

const BusinessAssurance = () => {
  const { t, i18n } = useTranslation()


  return (
    <div className="container-business-assurance">
      <div data-aos="fade-right" className="texts-business-assurance">
        <h1>{t("home.business_assurance_section.title")}</h1>
        <p>{t("home.business_assurance_section.section_text")}</p>
      </div>
      <div data-aos="flip-left" className="video-business-assurance">
        {/* <iframe 
        src="https://www.youtube.com/watch?v=lw9JvTopeZ8" 
        title="YouTube video player"
       /> */}

        <VideoComponent currentLanguage={i18n.language} />
        {/* <iframe src="https://www.youtube.com/embed/_bPC1DFF_8I" title="YouTube video player"></iframe> */}
      </div>
    </div>
  );
};
export default BusinessAssurance;
